// extracted by mini-css-extract-plugin
export var socialsRow = "links-module--socials-row--fmuBe";
export var socialImage = "links-module--social-image--8ZpLz";
export var youtubeVideo = "links-module--youtube-video--G7PrV";
export var mediaRow = "links-module--media-row--hDori";
export var tweet = "links-module--tweet--wfVpW";